export enum FetchUsersOrderByOptions {
  ALL = '',
  LAST_COMPLETED_SEQUENCE = 'last_completed_sequence_started_at',
  LAST_COMPLETED_FOCUS_MODE = 'last_completed_focus_mode_at',
  MORNING_ROUTINE_STREAK = 'morning_routines_streak',
  EVENING_ROUTINES_STREAK = 'evening_routines_streak',
  FOCUS_MODES_STREAK = 'focus_modes_streak',
  NONE = 'none'
}

export enum PAGINATE {
  TO_DO_TASKS = 'to-do-tasks',
  ADMIN_SURVEYS = 'admin-surveys',
  SURVEYS = 'surveys',
  ANNOUNCEMENTS = 'announcements'
}

export enum ANNOUNCEMENT_TYPE {
  RELEASE = 'release',
  EVENT = 'event',
  SURVEY = 'survey',
  MAINTENANCE = 'maintenance'
}

export enum ANNOUNCEMENT_PRIORITY {
  LOW = 'low',
  MEDIUM = 'medium',
  HIGH = 'high',
  CRITICAL = 'critical'
}

// Sentinel for "no filter selected" in the admin list — empty string avoids
// colliding with ANNOUNCEMENT_OS.ALL ('all').
export enum ANNOUNCEMENT_LIST_FILTER {
  ALL = ''
}

// Distinct from OPERATING_SYSTEM: matches the announcements API contract
// (lowercase, plus `all`/`unknown`). Do not conflate the two.
export enum ANNOUNCEMENT_OS {
  ALL = 'all',
  IOS = 'ios',
  ANDROID = 'android',
  MAC = 'mac',
  WINDOWS = 'windows',
  WEB = 'web',
  UNKNOWN = 'unknown'
}

export enum FLAG {
  SETTINGS_UPDATED = 'settings-updated',
  GEEK_MODE = 'geek-mode',
  SIMPLE_MODE = 'simple-mode',
  DISABLE_EDIT_HABITS = 'disable-edit-habits',
  SAVE_SETTINGS_MIGRATE_TO_WEB = 'save-settings-migrate-to-web',
  CONTINUE_SAVING_HABITS = 'continue-saving-habits',
  ONBOARDING_IN_PROGRESS = 'onboarding-in-progress',
  CUSTOM_ROUTINES_DEV_MODE = 'custom_routines_dev_mode',
  SKIP_SYNC_BACK_TO_DESKTOP = 'skip-sync-back-to-desktop'
}

export enum LessonCompletionStatus {
  SELF_TAUGHT = 'SELF_TAUGHT',
  TUTORIAL = 'TUTORIAL'
}

export enum FEED_BACK_QUESTION {
  BOOLEAN = 'boolean',
  TEXT = 'text',
  NUMBER = 'number',
  TEXT_AND_RATING = 'text-and-rating'
}
